// extracted by mini-css-extract-plugin
export default {"firstRowColor":"tbody_firstRowColor__EWiKa","secondRowColor":"tbody_secondRowColor__T9k3M"};